module.exports = __webpack_public_path__ + "static/Banner carrousel home Enero-04-53076cb005aef78fc2330621e8c00a54.jpg";